var DEFAULT_RESOLUTIONS = {
    small: 432,
    medium: 448,
    large: 516,
    xlarge: 670,
    xlargest: 670
};
export var LEFT_RIGHT_POSITION_RESOLUTIONS = {
    small: 480,
    medium: 512,
    large: 666,
    xlarge: 872,
    xlargest: 1470
};
export var TOP_POSITION_RESOLUTIONS = {
    small: 480,
    medium: 1024,
    large: 1160,
    xlarge: 1520,
    xlargest: 2560
};
var imageSectionImageResolutions = new Map([
    ['LEFT', LEFT_RIGHT_POSITION_RESOLUTIONS],
    ['RIGHT', LEFT_RIGHT_POSITION_RESOLUTIONS],
    ['TOP', TOP_POSITION_RESOLUTIONS]
]);
// eslint-disable-next-line import/prefer-default-export
export var getImageSectionResolutions = function (position) {
    return imageSectionImageResolutions.get(position) || DEFAULT_RESOLUTIONS;
};
